import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/account-details',
    name: 'AccountDetailsPage',
    component: () => import('@/modules/accountDetails/views/AccountDetailsPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
